import { render, staticRenderFns } from "./ReassignModalForm.vue?vue&type=template&id=32b163ce&scoped=true&"
import script from "./ReassignModalForm.vue?vue&type=script&lang=js&"
export * from "./ReassignModalForm.vue?vue&type=script&lang=js&"
import style0 from "./ReassignModalForm.vue?vue&type=style&index=0&id=32b163ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b163ce",
  null
  
)

export default component.exports